export const Logo = ({ onClick, testId = "header-logo" }) => (
    <button
        type="button"
        data-testid={testId}
        onClick={onClick}
        className="flex items-center gap-2.5"
        aria-label="TECNO-LAV - Vai alla home"
    >
        <img src="/assets/logo-mark.png" alt="Logo TECNO-LAV" className="h-9 w-9 object-contain mix-blend-screen" />
        <span className="font-display text-lg font-extrabold tracking-tight text-white">
            TECNO<span className="text-tl-orange">-</span>LAV
        </span>
    </button>
);
